// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_control_v1_ident_provider.ml",
  62,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [[
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "to_int"
                            ],
                            [
                              /* Function */ 0,
                              "from_int"
                            ],
                            [
                              /* Function */ 0,
                              "from_int_exn"
                            ],
                            [
                              /* Function */ 0,
                              "to_string"
                            ],
                            [
                              /* Function */ 0,
                              "from_string_exn"
                            ]
                          ]
                        },
                        "IdentProvider"
                      ]]
                  },
                  "V1"
                ]]
            },
            "Control"
          ]]
      },
      "Ident"
    ]]
});

const Ident = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_control_v1_ident_provider.ml",
  89,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "IdentProvider"
                ]]
            },
            "V1"
          ]]
      },
      "Control"
    ]]
});

const Control = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_control_v1_ident_provider.ml",
  114,
  10
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "IdentProvider"
          ]]
      },
      "V1"
    ]]
});

const V1 = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_control_v1_ident_provider.ml",
  137,
  12
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "IdentProvider"
    ]]
});

const IdentProvider = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_control_v1_ident_provider.ml",
  158,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.ident.control.v1.IdentProvider";
}

function to_int(param) {
  switch (param) {
    case /* IDENT_PROVIDER_UNSPECIFIED */ 0 :
      return 0;
    case /* IDENT_PROVIDER_COID */ 1 :
      return 100;
    case /* IDENT_PROVIDER_VERIGRAM */ 2 :
      return 200;
    case /* IDENT_PROVIDER_EGOV_DOC */ 3 :
      return 300;
  }
}

function from_int_exn(n) {
  if (n >= 101) {
    if (n !== 200) {
      if (n !== 300) {
        return Ocaml_protoc_plugin__Result.raise({
          NAME: "Unknown_enum_value",
          VAL: n
        });
      } else {
        return /* IDENT_PROVIDER_EGOV_DOC */ 3;
      }
    } else {
      return /* IDENT_PROVIDER_VERIGRAM */ 2;
    }
  } else if (n !== 0) {
    if (n >= 100) {
      return /* IDENT_PROVIDER_COID */ 1;
    } else {
      return Ocaml_protoc_plugin__Result.raise({
        NAME: "Unknown_enum_value",
        VAL: n
      });
    }
  } else {
    return /* IDENT_PROVIDER_UNSPECIFIED */ 0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return from_int_exn(e);
  });
}

function to_string(param) {
  switch (param) {
    case /* IDENT_PROVIDER_UNSPECIFIED */ 0 :
      return "IDENT_PROVIDER_UNSPECIFIED";
    case /* IDENT_PROVIDER_COID */ 1 :
      return "IDENT_PROVIDER_COID";
    case /* IDENT_PROVIDER_VERIGRAM */ 2 :
      return "IDENT_PROVIDER_VERIGRAM";
    case /* IDENT_PROVIDER_EGOV_DOC */ 3 :
      return "IDENT_PROVIDER_EGOV_DOC";
  }
}

function from_string_exn(s) {
  switch (s) {
    case "IDENT_PROVIDER_COID" :
      return /* IDENT_PROVIDER_COID */ 1;
    case "IDENT_PROVIDER_EGOV_DOC" :
      return /* IDENT_PROVIDER_EGOV_DOC */ 3;
    case "IDENT_PROVIDER_UNSPECIFIED" :
      return /* IDENT_PROVIDER_UNSPECIFIED */ 0;
    case "IDENT_PROVIDER_VERIGRAM" :
      return /* IDENT_PROVIDER_VERIGRAM */ 2;
    default:
      return Ocaml_protoc_plugin__Result.raise({
        NAME: "Unknown_enum_name",
        VAL: s
      });
  }
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
}, IdentProvider, {
  name: name,
  to_int: to_int,
  from_int: from_int,
  from_int_exn: from_int_exn,
  to_string: to_string,
  from_string_exn: from_string_exn
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "IdentProvider"
    ]]
}, V1, {
  IdentProvider: IdentProvider
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "IdentProvider"
          ]]
      },
      "V1"
    ]]
}, Control, {
  V1: V1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "IdentProvider"
                ]]
            },
            "V1"
          ]]
      },
      "Control"
    ]]
}, Ident, {
  Control: Control
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [[
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "to_int"
                            ],
                            [
                              /* Function */ 0,
                              "from_int"
                            ],
                            [
                              /* Function */ 0,
                              "from_int_exn"
                            ],
                            [
                              /* Function */ 0,
                              "to_string"
                            ],
                            [
                              /* Function */ 0,
                              "from_string_exn"
                            ]
                          ]
                        },
                        "IdentProvider"
                      ]]
                  },
                  "V1"
                ]]
            },
            "Control"
          ]]
      },
      "Ident"
    ]]
}, Buhta, {
  Ident: Ident
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
